import React, { useState } from "react";
import { useDocumentData } from "app/hooks/useDocumentData";
import { useApprovalLogic } from "app/hooks/useApprovalLogic";
import { useApprovers } from "app/hooks/useApprovers";
import { ToastContainer } from "react-toastify";
import DocumentHeader from "./ApprovalSysytem/DocumentHeader";
import ApproverFlow from "./ApprovalSysytem/ApproverFlow";
import ApprovalForm from "./ApprovalSysytem/ApprovalForm";
import DocumentViewer from "./ApprovalSysytem/DocumentViewer";
import { useParams } from "app/hooks/useParams";
import { useApprovalSubmit } from "app/hooks/useApprovalSubmit";
import { Alert, CircularProgress, Box, Typography } from "@mui/material";

const DocumentApprovalForHrNew = () => {
  const params = useParams();
  const { 
    requests, 
    approvalStatus, 
    updateHistory, 
    isLoading: loadingData, 
    error: dataError 
  } = useDocumentData(params);

  console.log("requests", requests)
  
  const { 
    approvers, 
    currentIndex, 
    isLoading: loadingApprovers, 
    error: approversError 
  } = useApprovers(params);
  
  const { 
    approvalData, 
    handleApprovalChange,
    allApprovalData 
  } = useApprovalLogic(approvers, currentIndex);
  
  console.log("approvalData", approvalData)
  const { 
    handleSubmit, 
    isSubmitting 
  } = useApprovalSubmit(
    params, 
    requests, 
    approvers, 
    allApprovalData, 
    currentIndex,
    approvalStatus,
    updateHistory
  );

  const [openViewRequest, setOpenViewRequest] = useState(false);

  // Combine approvers from document approval and material workflow
  const combinedApprovers = approvalStatus?.Approve || approvers;

  // Show loading state
  if (loadingData || loadingApprovers) {
    return (
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        height: '100vh',
        p: 3 
      }}>
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ mt: 2 }}>
          Loading document approval...
        </Typography>
      </Box>
    );
  }

  // Show error state
  if (dataError || approversError) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          {dataError || approversError}
        </Alert>
        <Typography>
          Please check the URL parameters and try again.
        </Typography>
      </Box>
    );
  }

  // Check if required params are present
  if (!params.WorkflowName || !params.Id) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="warning">
          Missing required parameters. Please ensure you're accessing this page with the correct URL.
        </Alert>
        <Typography variant="h6" sx={{ mt: 2 }}>
          Required URL parameters:
        </Typography>
        <ul>
          <li>Document_Type (e.g., Leave, timesheet, payroll management)</li>
          <li>id (document ID)</li>
          <li>documentapprovalid (approval ID)</li>
          <li>index (approver index)</li>
          <li>Comments (comment index)</li>
        </ul>
      </Box>
    );
  }

  const currentApproval = approvalData || {};

  return (
    <>
      <Box sx={{ padding: 4, backgroundColor: "#FFFFFF", minHeight: '100vh' }}>
        <ToastContainer autoClose={1000} />
        
        <DocumentHeader 
          workflowName={params.WorkflowName}
          requests={requests}
          onViewDocument={() => setOpenViewRequest(true)}
        />

        <ApproverFlow 
          approvers={combinedApprovers} 
          currentIndex={currentIndex} 
        />

        <ApprovalForm
          approvalData={currentApproval}
          onChange={(field, value) => handleApprovalChange(field, value)}
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          isAlreadyApproved={currentApproval.OneTimeApproved_flg}
        />
      </Box>

      <DocumentViewer
        type={params.WorkflowName}
        isOpen={openViewRequest}
        onClose={() => setOpenViewRequest(false)}
        requests={requests}
        approvers={combinedApprovers}
        approvalStatus={approvalStatus}
        updateHistory={updateHistory}
      />
    </>
  );
};

export default DocumentApprovalForHrNew;